/**
 * Archivo: MenusComedorServicios.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este fichero contiene las funciones para interactuar con la API de menús del comedor. 
 * Incluye funciones para listar, añadir, actualizar, eliminar y descargar PDFs de menús.
 * 
 * Dependencias:
 * - js-cookie: ^3.0.1
 * 
 * Propósito:
 * Proveer funciones para gestionar los datos de los menús del comedor, incluyendo su interacción con la base de datos a través del backend.
 */
const API = process.env.REACT_APP_API_BASE_URL; 

// Función para obtener los menús de la base de datos
export const listaMenus = async (token) => {
    const urlMenus = `${API}/api/menus`;
    try {
        const response = await fetch(urlMenus, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        const data = await response.json();
        //console.log("Respuesta de la API:", data);
        if (data.message === 'OK') {
            return { success: true, data: data.body };
        } else {
            return { success: false, message: data.message };
        }
    } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        return { success: false, message: 'Error al enviar la solicitud' };
    }
};

// Función para añadir un menú a la base de datos
export const añadirMenu = async (token, formData) => {
    const urlAddMenu = `${API}/api/menus`;
  // console.log("Añadir menú dentro del servicios", formData);
  // for (let pair of formData.entries()) {
  //   console.log(pair[0]+ ': ' + pair[1]);
  // }
  try {
      const response = await fetch(urlAddMenu, {
          method: 'POST',
          headers: {
              'Authorization': `Bearer ${token}`,
          },
          body: formData,
      });

      const data = await response.json();
      //console.log("Respuesta de la API:", data);
      if (data.success) {
          return { success: true, data: data.data };
      } else {
          return { success: false, message: data.message };
      }
  } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return { success: false, message: 'Error al enviar la solicitud' };
  }
};

// Función para actualizar un menú
export const actualizarMenu = async (token, formData) => {
  const urlUpdateMenu = `${API}/api/menus`;
  // console.log("actualizando menú dentro del servicios", formData);
  // for (let pair of formData.entries()) {
  //   console.log(pair[0]+ ': ' + pair[1]);
  // }
  try {
      const response = await fetch(urlUpdateMenu, {
          method: 'PUT',
          headers: {
              'Authorization': `Bearer ${token}`,
          },
          body: formData,
      });

      const data = await response.json();
      //console.log("Respuesta de la API:", data);
      if (data.success) {
          return { success: true, data: data.data };
      } else {
          return { success: false, message: data.message };
      }
  } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return { success: false, message: 'Error al enviar la solicitud' };
  }
};

// Función para eliminar un menú
export const eliminarMenu = async (token, id_menu) => {
  const urlEliminarMenu = `${API}/api/menus`;
  try {
      const response = await fetch(urlEliminarMenu, {
          method: 'DELETE',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ id_menu }),
      });

      const data = await response.json();
      //console.log("Respuesta de la API:", data);
      if (data.success) {
          return { success: true, data: data.data };
      } else {
          return { success: false, message: data.message };
      }
  } catch (error) {
      console.error('Error al enviar la solicitud:', error);
      return { success: false, message: 'Error al enviar la solicitud' };
  }
};


export const descargarMenuPDF = async (token, id_menu) => {
  const urlDescargarPDF = `${API}/api/menus/descargarPDF`;
  try {
      const response = await fetch(urlDescargarPDF, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ id_menu }),
      });
      if (!response.ok) {
          const errorData = await response.json();
          return { success: false, message: errorData.message };
      }

      const blob = await response.blob();
      return { success: true, data: blob };
  } catch (error) {
      return { success: false, message: 'Error al descargar PDF' };
  }
};